import { render, staticRenderFns } from "./zones-table.vue?vue&type=template&id=05a5c510&"
import script from "./zones-table.vue?vue&type=script&lang=js&"
export * from "./zones-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports